/** @jsxImportSource @emotion/react */

import { FieldProps } from 'formik';
import { useContext } from 'react';

import { css, SerializedStyles } from '@emotion/react';

import { InputThemeVariant } from '..';
import { FormContext } from '../context';

export const InputTextarea = ({
    form,
    field,
    meta,
    ...restProps
}: FieldProps) => {
    return (
        <textarea
            css={InputVariants['ghostRounded']}
            {...field}
            {...restProps}
        />
    );
};

const InputVariants: Record<InputThemeVariant, SerializedStyles> = {
    ghostRounded: css`
        border: 1px solid #000000;
        padding: 15px 20px;
        border-radius: 50px;
    `,
};
